<template>
  <div>
    <div class="flex justify-between">
      <div class="text-left">
        <div class="font-bold">
          {{ applicationName1 }}
        </div>
        <div>
          {{ headerName1 }}
        </div>
      </div>
      <div class="text-right">
        <div class="font-bold">
          {{ applicationName2 }}
        </div>
        <div>
          {{ headerName2 }}
        </div>
      </div>
    </div>
    <div class="flex justify-between my-2" v-for="(mappingTable, idx) in form" :key="idx">
      <input
        type="text"
        class="w-1/2 form-control form-input form-input-bordered mr-2"
        v-model="mappingTable.value_1"
        :class="{ 'is-invalid': hasError(idx, 'value_1') }"
      />
      <span class="w-40 text-center">&lt;-&gt;</span>
      <input
          type="text"
          class="w-1/2 form-control form-input form-input-bordered"
          v-model="mappingTable.value_2"
          :class="{ 'is-invalid': hasError(idx, 'value_2') }"
      />
      <button
        type="button"
        class="ml-4 delete-button w-full cursor-pointer absolute"
        style="right: 32px"
        @click="removeRow(idx)"
      >
        X
      </button>
    </div>
    <div class="flex mt-4">
      <button type="button" @click="addRow" class="button button_success">
        {{ trans('common.add') }}
      </button>
      <button v-if="!fromDataManipulationOptions && canSave" type="button" @click="saveMappingTables" class="button">
        {{ trans('common.save') }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'MappingTable',

  props: {
    application1: {
      type: Object,
      default: null,
    },

    application2: {
      type: Object,
      default: null,
    },

    header1: {
      type: [Object, String],
      required: true,
    },

    header2: {
      type: [Object, String],
      required: true,
    },

    mappingTables: {
      type: Array,
      required: true,
    },

    settingId: {
      type: Number,
      default: null,
    },

    isUserIntegration: {
      type: Boolean,
      default: false,
    },

    isUserIntegrationFlow: {
      type: Boolean,
      default: false,
    },

    id: {
      type: [Number, String],
      required: true,
    },

    fromDataManipulationOptions: {
      type: Boolean,
      default: false,
    },

    errors: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      form: [],
    };
  },

  beforeMount() {
    JSON.parse(JSON.stringify(this.mappingTables)).forEach(mappingTable => {
      if (this.fromDataManipulationOptions) {
        mappingTable.value_1 = mappingTable.input_value;
        mappingTable.value_2 = mappingTable.output_value;
      }

      this.form.push(mappingTable);
    });
  },

  computed: {
    applicationName1() {
      return this.application1 !== null ? this.application1.name : '';
    },

    applicationName2() {
      return this.application2 !== null ? this.application2.name : '';
    },

    headerName1() {
      return this.header1.header || this.header1;
    },

    headerName2() {
      return this.header2.header || this.header2;
    },

    canSave() {
      return this.isUserIntegrationFlow
        ? this.$can('flows.settings.update')
        : this.$can('integrations.settings.update');
    },
  },

  methods: {
    addRow() {
      this.form.push({
        value_1: '',
        value_2: '',
      });
    },

    removeRow(index) {
      this.form.splice(index, 1);
    },

    saveMappingTables() {
      const data = {
        setting_id: this.settingId,
        mappingTables: this.form,
      };

      if (this.isUserIntegration) {
        data.userIntegrationId = this.id;
      } else if (this.isUserIntegrationFlow) {
        data.userIntegrationFlowId = this.id;
      }

      axios
        .post('/mapping-table', data)
        .then(() => {
          Swal.fire({
            text: this.trans('dashboard.alerts.success_save_mapping_table'),
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
          });
        })
        .catch(() => {
          Swal.fire({
            text: this.trans('dashboard.alerts.failed_save_mapping_table'),
            icon: 'error',
            showConfirmButton: false,
            timer: 2000,
          });
        });
    },
    hasError(index,field) {
      return this.errors?.[`mapping_tables.${index}.${field}`];
    },
  },

  watch: {
    form: {
      deep: true,
      handler(current) {
        this.$emit('updated', current);
      },
    },
  },
};
</script>

<style scoped>
.delete-button {
  font-size: 1rem;
  background-color: #d34e59;
  color: #ffffff;
  border-radius: 18px;
  text-align: center;
  line-height: 36px;
  max-width: 36px;
  max-height: 36px;
}
</style>
